import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MonthData } from 'src/app/models/monthly-reports.interfaces';

@Component({
  selector: 'app-monthly-reports-card',
  templateUrl: './monthly-reports-card.component.html',
  styleUrls: ['./monthly-reports-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyReportsCardComponent {
  @Input() cardMonthly!: MonthData;
}
